import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "reactstrap";

import { OptionsWhyWithoutTIN, PersonType } from "../types";
import { FormField, SelectFormField, CustomFormInput } from "../../../../utils/FormFields";
import Autosuggest from "../../../AutosuggestCompliance";

function FiscalResidence({
  person,
  onChange,
  documentTypes,
  autosuggests,
  onChangeAutosuggest,
  disabled,
  errors,
  services,
}) {
  const fetchCountrySuggestion = (name) =>
    new Promise((resolve, reject) => {
      services.fetchAutosuggestCoutries({ text: name }, (response) => {
        if (response && response.countries) {
          const suggestions = [];
          response.countries.map((c) => {
            suggestions.push({
              id: c.Id,
              name: c.Name,
            });
            return {};
          });
          resolve(suggestions);
        } else {
          reject();
        }
      });
    });

  const onChangeCountry = (value) => onChangeAutosuggest("PersonFiscalResidenceCountry", value);

  const handleSelectCountry = (id, value) => {
    onChange("PersonFiscalResidenceCountryId", id, value);
    onChangeCountry(value);
  };

  return (
    <div>
      <Row>
        <Col>
          <CustomFormInput label="Fiscal Residence Country: " error={errors.PersonFiscalResidenceCountryId}>
            <Autosuggest
              value={autosuggests.PersonFiscalResidenceCountry}
              onChange={onChangeCountry}
              fecthSuggestions={fetchCountrySuggestion}
              onSelect={handleSelectCountry}
              disabled={disabled}
            />
          </CustomFormInput>
        </Col>
        {person.PersonType === PersonType.Physical && documentTypes && (
          <React.Fragment>
            <Col>
              <SelectFormField
                label="Fiscal Id Type: "
                value={person.PersonFiscalResidenceTaxId}
                name="PersonFiscalResidenceTaxId"
                onChange={onChange}
                selectItems={[{ DocumentTypeId: "", DocumentTypeName: "" }].concat(documentTypes)}
                getSelectItemId={(i) => i.DocumentTypeId}
                getSelectItemName={(i) => i.DocumentTypeName}
                disabled={disabled}
                error={errors.PersonFiscalResidenceTaxId}
              />
            </Col>
            <Col>
              <FormField
                label="TIN: "
                value={person.PersonFiscalResidenceTIN}
                name="PersonFiscalResidenceTIN"
                onChange={onChange}
                disabled={disabled}
                error={errors.PersonFiscalResidenceTIN}
              />
            </Col>
          </React.Fragment>
        )}
      </Row>
      {person.PersonType === PersonType.Physical && person.PersonFiscalResidenceTIN === "" && (
        <React.Fragment>
          <SelectFormField
            label="Option: "
            value={person.PersonFiscalResidenceNoTINOpt}
            name="PersonFiscalResidenceNoTINOpt"
            onChange={onChange}
            selectItems={OptionsWhyWithoutTIN}
            getSelectItemId={(item) => item.id}
            getSelectItemName={(item) => item.text}
            disabled={disabled}
            error={errors.PersonFiscalResidenceNoTINOpt}
          />
          <FormField
            label="Option B Specify: "
            value={person.PersonFiscalResidenceNoTINSpecify}
            name="PersonFiscalResidenceNoTINSpecify"
            type="textarea"
            onChange={onChange}
            disabled={disabled}
            error={errors.PersonFiscalResidenceNoTINSpecify}
          />
        </React.Fragment>
      )}
    </div>
  );
}

FiscalResidence.propTypes = {
  person: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  autosuggests: PropTypes.object.isRequired,
  onChangeAutosuggest: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  errors: PropTypes.object.isRequired,
  services: PropTypes.object.isRequired,
};

export default FiscalResidence;
